import React, { useEffect, useState } from 'react'
import styles from "./styles.module.css"
import { userRequest } from '../../requestMethod'
import { Button, Skeleton } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { ImLocation } from "react-icons/im";
import { BsClockFill } from "react-icons/bs";
import Pencil from "../../assets/icons/Pencil.svg"
import phoneWithMap from "../../assets/for_this/phoneWithMap.svg"
import blankPhone from "../../assets/for_this/blankPhone.svg"
import restaurant_icon from "../../assets/for_this/restaurant_icon.png"
import bank_icon from "../../assets/for_this/bank_icon.png"
import bar_icon from "../../assets/for_this/bar_icon.png"
import bowling_icon from "../../assets/for_this/bowling_icon.png"
import gym_icon from "../../assets/for_this/gym_icon.png"
import Carouser from './Crouser'
import StarRating from './StartRating'
import send from "../../assets/for_this/sendIcon.svg"
import calendarClock from "../../assets/for_this/calendarClock.svg"
import { AiOutlineRight } from 'react-icons/ai'


const Profile = () => {
    const [data, setData] = useState({});
    const [businessData, setBusinessData] = useState(null);
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const userId = JSON.parse(localStorage.getItem("userId"))
    const getData = () => {
        setLoading(true)
        userRequest.get(`/partner/business/getBusiness?_id=${userId}`).then((res) => {
            setData(res.data.data)
            setLoading(false);
            const currentDay = new Date().toLocaleString('en-US', { weekday: 'short' }).toLowerCase();;
            const currentDayData = res.data.data.buinessSchedule.find(item => item.day.toLowerCase() === currentDay);
            setBusinessData(currentDayData);
        })
    }
  
    useEffect(() => {
        getData()
    }, [])

    const getImg = (value) => {
        if (value === "Restaurant") {
            return restaurant_icon
        }
        if (value === "bank") {
            return bank_icon
        }
        if (value === "Bar") {
            return bar_icon
        }
        if (value === "gym") {
            return gym_icon
        }
        if (value === "bowling") {
            return bowling_icon
        }
    }

    function getFirstThreeWords(inputString) {
        // Split the input string into words
        var words = inputString?.split(/\s+/);
        // Take the first three words and join them back into a string
        var result = words?.slice(0, 3).join(' ');
        return result;
    }

    return (
        <div className={styles.mainContainer}>
            <h1 className={styles.profileView}>My Profile</h1>
            <div className={styles.container}>
                <div>
                    <div className={styles.profileImgDiv}>
                        <img className={styles.profileImg} src={data.photos && data?.photos[0]} alt="" />
                    </div>
                    <div>
                        <h2 className={styles.dataName} style={{marginTop:'2%'}}>{data.name}</h2>
                        <StarRating rating={0} numRatings={5} />
                        <p style={{fontWeight:'normal'}}> {data?.category}</p>

                        <span className={styles.address}><ImLocation /> {getFirstThreeWords(data?.address)}</span>
                        <span className={styles.time}>
                  {businessData?.status=== true ? (
                     <><span>
                                    <BsClockFill /> OPEN TILL {businessData?.to}
                                </span><AiOutlineRight /></>
        ) : (
            ""
        )}
    </span>
                    </div>


                </div>

                <div className={styles.password}>
                    <div className={styles.editBtn}>
                        <Button w={127} bg="#8CC9E9" padding="10px 20px" onClick={() => navigate("/EditProfile")}> <img src={Pencil} style={{ width: "15px", }} alt='' /> &nbsp; Edit Profile</Button>
                    </div>

                    <div className={styles.phoneDivMain} >
                        <p>Preview of my profile</p>
                        <div className={styles.phoneDiv}>

                            {
                                
                                loading ? <div>
                                    <Skeleton height="67vh" width="16vw" borderRadius={30} />
                                </div> : <div className={styles.WithMap}>
                                    <span className={styles.spanClass}>
                                     <img className={styles.profileImg2} src="https://images.pexels.com/photos/3887985/pexels-photo-3887985.jpeg?cs=srgb&dl=pexels-volkan-vardar-3887985.jpg&fm=jpg" alt="" />
                                        <p className={styles.userNames}>{data.name}</p>
                                    </span>
                                    <img className={styles.categoryIcon} src={getImg(data.category)} alt="" />
                                    <img src={phoneWithMap} className={styles.phoneWithMapImg} alt="" />
                                </div>
                            }
                            { 
                                loading ? <div>
                                    <Skeleton height="67vh" width="16vw" borderRadius={30} />
                                </div> :
                                    <div className={styles.WithMap2} >
                                        <Carouser images={data?.photos} />
                                        <div className={styles.phoneContent}>
                                            
                                            <div className={styles.phoneInner1}>
                                                <div>
                                                    <h2 className={styles.name}>{data.name}</h2>
                                                    <StarRating rating={0} numRatings={5} />
                                                    <p className={styles.category}> {data.category}</p>

                                                </div>
                                                <div className={styles.phoneInner11}>
                                                    <img src={send} alt="" />
                                                    <p className={styles.category}> Get Directions</p>
                                                </div>
                                            </div>

                                            <div className={styles.phoneInner2}>
                                                <span className={styles.address1}><ImLocation /> {getFirstThreeWords(data?.address)}</span>
                                                                       
                                            {  businessData?.status===true ? (
                                                <span className={styles.time}><span>
                                                    <BsClockFill />Closing Time {businessData?.to}</span>
                                                </span>
                                            ) : (
                                                ""
                                            )
                                              }
                                            </div>
                                            <div className={styles.phoneInner3}>
                                                <span className={styles.time}>
                                                <span><img src={calendarClock} alt='' />Select Date & Time</span> 
                                                <AiOutlineRight />
                                                </span>

                                            </div>

                                        </div>
                                        <img className={styles.sliderPhone} src={blankPhone} alt="" />
                                    </div>
                            }
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Profile